// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"ShoppingPart_PageHolder__1yFYq","TabsTitle":"ShoppingPart_TabsTitle__2Zi4k","normal":"ShoppingPart_normal__3-fvp","checked":"ShoppingPart_checked__AjeIX"};